import { NavHeader } from '../../components';
import { ReportFinancial } from '../../components/ReportFinancial';
import { Container } from './styles';

export function Financial() {
  return (
    <>
      <NavHeader typeHeader="company" />
      <Container>
        <ReportFinancial />
      </Container>
    </>
  );
}
